import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"wrapper",attrs:{"tag":"div","to":_vm.to,"active-class":"mobile-active"}},[_c(VIcon,{staticClass:"icon",attrs:{"color":_vm.$route.path === _vm.to ? 'red' : null,"size":"40"}},[_vm._v(_vm._s(_vm.icon))]),_c('p',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }